var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNOnuowei(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-icon_NOnuowei",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M470.88 186.15H960v244.1H470.88zM470.88 593.64H960v244.21H470.88zM64 186.15h244.3v244.1H64zM64 593.64h244.3v244.21H64z",
    fill: "#EF2A2D",
    opacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M430.4 552.79v285.06h40.48V593.64H960v-40.85H470.88zM470.88 430.25v-244.1H430.4v284.94H960v-40.84zM308.3 430.25H64v40.84H348.78V186.15H308.3zM64 552.79v40.85h244.3v244.21h40.48V552.79H308.3z",
    fill: "#FFFFFF",
    opacity: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M944 430.25h16v40.84h-16z",
    fill: "#EEEEEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M944 186.15h16v244.1h-16zM944 593.64h16v244.21h-16z",
    fill: "#EF2A2D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M944 552.79h16v40.84h-16z",
    fill: "#EEEEEE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M944 471.09h16v81.7h-16z",
    fill: "#002968"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M430.4 186.15h40.48v16H430.4z",
    fill: "#EEEEEE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M348.78 186.15h81.62v16h-81.62z",
    fill: "#002968"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M470.88 186.15H960v16H470.88z",
    fill: "#EF2A2D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M308.3 186.15h40.48v16H308.3z",
    fill: "#EEEEEE"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M64 186.15h244.3v16H64z",
    fill: "#EF2A2D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M430.4 821.85h40.48v16H430.4z",
    fill: "#EEEEEE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M348.78 821.85h81.62v16h-81.62z",
    fill: "#002968"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M470.88 821.85H960v16H470.88z",
    fill: "#EF2A2D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M308.3 821.85h40.48v16H308.3z",
    fill: "#EEEEEE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M64 821.85h244.3v16H64z",
    fill: "#EF2A2D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M470.88 471.09H430.4V186.15h-81.62v284.94H64v81.7H348.78v285.06h81.62V552.79H960v-81.7z",
    fill: "#002968",
    opacity: 0.75
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M64 430.25h16v40.84H64z",
    fill: "#EEEEEE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M64 186.15h16v244.1H64zM64 593.64h16v244.21H64z",
    fill: "#EF2A2D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M64 552.79h16v40.84H64z",
    fill: "#EEEEEE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M64 471.09h16v81.7H64z",
    fill: "#002968"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNOnuowei);
export default __webpack_public_path__ + "static/media/icon_NOnuowei.1de2e8b054535b922b75aa67e7c5b38b.svg";
export { ForwardRef as ReactComponent };